<template>
  <b-container class="px-0 mx-0 active" fluid="true" style="height: 100%" >
    <VBox style="position: relative; z-index: 0;">
          <DataGrid2
              data-test-path="attachment-grid"
              ref="grid"
              name="attachmentDialog"
              v-model="listOfSelectedAttachments"
              :selectedIndex.sync="selectedIndex"
              :items="attachmentsList"
              :columns="fields"
              :headerShowReload="false"
              searchBarClass="d-none d-md-block"
              select-mode="range"
              @rows-selected="onRowSelected"
              filtersColsClasses="col-xl-auto col-md-auto col"
              :show-add="false"
              :show-delete="!readOnly"
              :show-details="false"
              @delete="deleteAttachment"
              :multi-select-auto-on="false"
          >
            <template v-slot:primaryButtons>
              <edit-save-button v-if="!isJoined && canEdit &&
                  (! validatedField || !validatedField.validatedForm || !validatedField.validatedForm.restrictedWrite ||
                   validatedField.validatedForm.permissions[validatedField.validatedForm.effectivePermissionWrite])"

                :save-edit-mode="readOnly"
                @edit="edit"
                @save="onOk(false)"

              ></edit-save-button>

              <div class="col pt-1" style="min-width: 80px" v-if="!readOnly">
                <FileUpload
                    data-test-path="attachment-upload"
                    class="d-none d-md-block"
                    @file-selected="attachmentSelected"
                    ref="attachmentUpload"
                />

                <span class="d-block d-md-none" v-if="loading" style="width: 40px; padding-top: 5px">
                      {{ percentDone }} %
                    </span>
                <b-button v-else
                          class="d-block d-md-none"
                          variant="plm-toolbar-secondary"
                          @click="uploadAttachment"
                >
                  <font-awesome-icon icon="upload"/>
                </b-button>
              </div>

            </template>
            <template v-slot:middleButtons>
                <b-button
                    data-test-path="share-attachment"
                    :disabled="!listOfSelectedAttachments"
                    @click="shareAttachments"
                    class="d-none d-xl-block ml-1"
                    variant="plm-toolbar-secondary"
                >
                  <font-awesome-icon class="ml-1" icon="share-alt"/>
                  Share
                </b-button>
                <b-button
                    data-test-path="share-attachment"
                    :disabled="!listOfSelectedAttachments"
                    @click="shareAttachments"
                    class="d-block d-xl-none ml-1"
                    variant="plm-toolbar-secondary"
                >
                  <font-awesome-icon icon="share-alt"/>
                </b-button>
            </template>
          </DataGrid2>
    </VBox>
    <div class="row px-1 mx-0" v-if="!readOnly">
      <span v-if="numberOfUnsavedAttachments>1">{{numberOfUnsavedAttachments}} {{$tr('unsavedChanges','unsaved changes')}}</span>
      <span v-if="numberOfUnsavedAttachments === 1">{{$tr('1UnsavedChange','1 unsaved change')}}</span>
      <span v-if="!numberOfUnsavedAttachments"><i>{{$tr('noChanges','noChanges')}}</i></span>
    </div>
      <FooterNavbar data-test-path="attachment-dialog-footer" class="w-100">
        <CloseButton :read-only="readOnly" @close="onHide"></CloseButton>

        <save-and-close-button mode="EDIT" @save="onOk" v-if="!readOnly"></save-and-close-button>

      </FooterNavbar>
  </b-container>
</template>

<script>
import FooterNavbar from "@/components/navbar/FooterNavbar";
import VBox from "@/components/VBox";
import DataGrid2 from "@/components/datagrid/DataGrid2";
import FileUpload from "@/components/FileUpload";
import IconAttachment from "@/components/datagrid/IconAttachment";
import DialogManager from "@/utils/DialogManager";
import AttachmentName from "@/components/datagrid/AttachmentName";
import {getFileSizeFormatter} from "@/components/datagrid/ColumnFormatter";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import {AttachmentDialogResult} from "@/components/dialogs/results/AttachmentDialogResult";
import FooterButton from "@/components/navbar/FooterButton";
import Activity from "@/activity/Activity";
import FormValidatedField from "@/components/forms/FormValidatedField";
import Perms from "@/server/Perms";
import CloseButton from "@/components/navbar/CloseButton";
import SaveAndCloseButton from "@/components/navbar/SaveAndCloseButton";
import EditSaveButton from "@/components/layout/EditSaveButton";





export default {
  name: "AttachmentsActivity",
  components: {EditSaveButton, SaveAndCloseButton, CloseButton, FooterButton, FileUpload, DataGrid2, VBox, FooterNavbar},
  permission: null,

  created() {
    /** @type {Function} */
    this.attachmentLoad = null;
  },

  async beforeMount() {
    this.permission = this.validatedField?.getFormConfig?.()?.restrictedRead ? Perms[this.validatedField.getFormConfig().effectivePermissionRead] : null;
  },

  mounted() {
    this.unsavedTokens = [];
    this.deletedTokens = [];
    if(this.isJoined){
      this.readOnly = true;
    }

    /** @type {DataGrid2|Vue} */
    this.grid = this.$refs["grid"];
    this.attachmentsList = this.attachments;
    this.originalList = [...this.attachmentsList];
    if(this.editMode){
      this.edit();
    }
  },

  methods: {

    ...Activity.methods,

    getTitle(){
      return this.title;
    },

    uploadAttachment() {
      this.$refs.attachmentUpload.$refs.fileInput.click();
    },

    beforeClose(){
      if(this.result){
        this.setResult(this.result);
        return;
      }
      this.result = new AttachmentDialogResult();
      this.result.attachmentsList = this.originalList;
      this.result.numberOfUnsavedAttachments = 0;
      this.setResult(this.result);
    },

    async canClose(){
      if(this.result){
        return true;
      }
      if(!this.numberOfUnsavedAttachments){
        return true;
      }
      return await DialogManager.canClose(true);
    },

    async onOk(autoClose=true) {
      if (!autoClose) {
        this.unsavedTokens = [];
      }
      this.result = new AttachmentDialogResult();
      this.result.attachmentsList = this.attachmentsList;
      this.result.numberOfUnsavedAttachments = this.numberOfUnsavedAttachments;
      this.result.deletedTokens = this.deletedTokens;
      try {
        this.$emit("save", this.result);

        if(this.attachmentSaveFunction){
          let res = this.attachmentSaveFunction(this.result);
          if(res.lock){
            res = res.lock();
          }
          await res;
        }

        this.readOnly = true;
        autoClose && this.close();
      } catch (e) {
        await DialogManager.info($tr('saveFailed','Save failed'),$tr("attachmentsActivity.wasnt.save",
            "Attachments list wasn't save, please try again") );
        if (e instanceof RpcInputValidationException) {
          this.validatedField.validatedForm.parseException(e)
        } else {
          throw e;
        }
      }

    },

    async onHide(ev) {
      this.$emit("close", this.unsavedTokens);
      this.close();
    },

    reset() {
      this.result = null;
      this.resolve = null;
      this.readOnly = true;
    },

    edit() {
      this.readOnly = false;
    },

    async attachmentSelected() {
        let attachmentUpload = this.$refs.attachmentUpload;
        let file = attachmentUpload.getFile();
        this.loading = true;
        attachmentUpload.setProgress(0);
        try {
          let attachment = await Rpc.BusinessEntities.uploadAttachment(file).lock().onProgress((e) => {
            attachmentUpload.setProgress(e.percent);
            this.percentDone = Math.floor(e.percent);
          });
          if (attachment) {
            attachment.data.sizeLabel = getFileSizeFormatter(attachment.data.size);
            this.attachmentsList.push(attachment);
            this.numberOfUnsavedAttachments++;
            this.unsavedTokens.push(attachment.token);
          }
          this.loading = false;
          attachmentUpload.reset();
        } catch (e) {
          this.loading = false;
          if (e instanceof RpcInputValidationException) {
            attachmentUpload.setError(e.fields.image.errorMessage);
          } else {
            throw e;
          }
        }
    },

    onRowSelected(items) {
      this.numberOfSelectedRows = items.length;
    },

    async deleteAttachment() {
      let listOfSelectedAttachments = this.listOfSelectedAttachments;
      const msg = this.numberOfSelectedRows === 1 ?
          $tr("attachments.sure.delete.attachment","Are you sure you want to delete this attachment?"):
          $tr("attachments.sure.delete.attachments",'Are you sure you want to delete this attachments?');

      if (await DialogManager.yesNo($tr("deletingAttachment","Deleting attachment"), msg)) {
        listOfSelectedAttachments.forEach(attachment => {
          this.deletedTokens.push(attachment.token);
        });
        await this.deleteAttachmentSubmit(listOfSelectedAttachments);
        }
    },

    download(){

    },
    async deleteAttachmentSubmit(listOfSelectedAttachments) {
      for (let i = 0; i < listOfSelectedAttachments.length; i++) {
        let originalResult = _.find(this.originalList, {token: listOfSelectedAttachments[i].token});
        let tempResult = _.find(this.attachmentsList, {token: listOfSelectedAttachments[i].token});
        if (originalResult) {
          this.numberOfUnsavedAttachments++;
        }
        if (!originalResult && tempResult) {
          this.numberOfUnsavedAttachments--;
        }
      }
      this.attachmentsList = _.difference(this.attachmentsList, listOfSelectedAttachments);
    },

    async shareAttachments() {
      await DialogManager.shareAttachmentDialog(this.listOfSelectedAttachments);
    }
  },
  model:{
    prop: "attachments",
    event: "change"
  },
  props: {
    attachmentUploadFunction: {default:null},
    attachmentSaveFunction: {default:null},
    attachments: { type:Array, default: () => []},
    validatedField: { type: FormValidatedField, required:false, default:null },
    isJoined: {type: Boolean, default: false},
    title: {type: String, default:""},
    canEdit: {type: Boolean, default: true},
    editMode: {type: Boolean, default: false},
  },

  data: () => ({
    attachmentsList: [],
    originalList: [],
    fields: [
      {
        name: 'File', size: 55, sortable: true, fixed: true,
        template: IconAttachment
      },
      {
        name: 'Name', size: 210, sortable: true,
        template: AttachmentName
      },
      {name: 'Size', sortable: true, size: 110, template: "<div>{{model.data.sizeLabel}}</div>"},
      {name: 'Uploaded by', sortable: true, size: 210, template: "<div>{{model.data.uplBy}}</div>"},
    ],
    type: null,
    resolve: null,
    /** @type{AttachmentDialogResult} */
    result: null,
    listOfSelectedAttachments: null,
    selectedIndex: null,
    selectedAttachmentIndex: null,
    numberOfSelectedRows: 0,
    readOnly: false,
    numberOfUnsavedAttachments: null,
    loading: false,
    percentDone: 0
  })
}

</script>
